import './BoxPicture.css';
import { useEffect, useState } from 'react';
import { loadSeason } from '@src/theme/registry';
import { isSeason, DEFAULT_GAME_SEASON, type Season } from '@src/theme/season';
import type { SeasonPackage } from '@src/theme/types';
import { useTheme } from '@src/theme/useTheme';
import { gamePictureIds, type GamePictureId } from '@src/theme/gamePictures';

export type BoxPictureType = GamePictureId | 'custom_image';
export const BOX_PICTURE_NAMES: BoxPictureType[] = [...gamePictureIds];

export interface BoxPictureProps {
  picture?: string | null;
  logo?: string | null;
  /** Use the game's artwork even when the surrounding page has another theme. */
  season?: Season;
}

/** The holiday drawing a game picked, or its uploaded logo. */
export function BoxPicture({ picture, logo, season: savedSeason }: BoxPictureProps) {
  const season = savedSeason && (isSeason(savedSeason) ? savedSeason : DEFAULT_GAME_SEASON);
  const { seasonPackage } = useTheme();
  const [loaded, setLoaded] = useState<SeasonPackage | null>(null);
  useEffect(() => {
    if (!season || season === seasonPackage.id || logo) return;
    let active = true;
    void loadSeason(season).then(pkg => { if (active) setLoaded(pkg); }).catch(() => {
      // Never substitute a different season's artwork when loading fails.
    });
    return () => { active = false; };
  }, [season, seasonPackage.id, logo]);
  if (logo) {
    return <img className="box-picture__custom" alt="" src={logo} />;
  }
  const artwork = !season || season === seasonPackage.id ? seasonPackage : loaded?.id === season ? loaded : null;
  if (!artwork) return null;
  const id = gamePictureIds.find((id) => id === picture) ?? 'santa';
  const Pic = picture === 'custom_image' ? artwork.photoArtwork : artwork.gamePictures[id];
  return <img className="box-picture__artwork" src={Pic} alt="" />;
}
